import ServicePerson from '../../src/legacy/ServicePerson.tsx';
export default ServicePerson;
